{
  "tabs": {
    "chat": "Chat",
    "reminders": "Lembretes",
    "calendar": "Calendário",
    "settings": "Configurações"
  },
  "common": {
    "cancel": "Cancelar",
    "save": "Salvar",
    "confirm": "Confirmar",
    "delete": "Excluir",
    "back": "Voltar",
    "close": "Fechar",
    "edit": "Editar",
    "search": "Buscar",
    "all": "Todos",
    "loading": "Carregando...",
    "error": "Algo deu errado",
    "notFound": "Não encontrado",
    "tryAgain": "Por favor, tente novamente",
    "retry": "Tentar novamente",
    "undo": "Desfazer",
    "pullToRefresh": "Puxe para atualizar",
    "justNow": "agora mesmo"
  },
  "auth": {
    "welcome": "Bem-vindo ao FishMemory",
    "tagline": "Seu assistente de lembretes do WhatsApp, agora no seu bolso.",
    "subtitle": "Seu assistente de lembretes do WhatsApp, agora no seu bolso.",
    "phoneLabel": "Seu número do WhatsApp",
    "phoneHint": "Enviaremos um código de verificação via WhatsApp",
    "invalidPhone": "Por favor, insira um número de telefone válido",
    "continue": "Continuar",
    "enterPhone": "Digite seu número do WhatsApp",
    "phonePlaceholder": "Número de telefone",
    "sendCode": "Enviar Código",
    "verifyTitle": "Verifique seu número",
    "otpSentTo": "Um código de 6 dígitos foi enviado para {{phone}} via WhatsApp",
    "enterFullCode": "Por favor, insira os 6 dígitos",
    "invalidOtp": "Código inválido. Tente novamente.",
    "otpFailed": "Falha ao enviar código. Tente novamente.",
    "otpResent": "Código reenviado",
    "resendIn": "Reenviar em {{seconds}}s",
    "resendCode": "Reenviar código",
    "enterOtp": "Digite o código enviado para seu WhatsApp",
    "verify": "Verificar",
    "resend": "Reenviar código",
    "wrongNumber": "Número errado?",
    "backToPhone": "Voltar ao telefone",
    "editPhone": "Editar número",
    "error": "Erro",
    "setupTitle": "Vamos configurar",
    "setupSubtitle": "Você pode alterar isso depois nas Configurações",
    "namePlaceholder": "Seu nome",
    "letsGo": "Finalizar configuração",
    "skipForNow": "Pular por enquanto"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Digite uma mensagem...",
    "inputPlaceholder": "Digite uma mensagem...",
    "typing": "FishMemory está digitando...",
    "online": "Online",
    "connecting": "Conectando...",
    "reconnecting": "Reconectando...",
    "offline": "Offline",
    "empty": "Inicie uma conversa",
    "emptyHint": "Crie lembretes, veja sua agenda ou peça ajuda.",
    "emptyAction": "Enviar lembrete de exemplo",
    "actions": "Ações do chat",
    "keep": "Manter mensagens",
    "clearTitle": "Limpar chat",
    "clearConfirm": "Excluir todas as mensagens deste dispositivo? Esta ação não pode ser desfeita.",
    "clear": "Limpar chat",
    "optionSelected": "Selecionado: {{label}}",
    "sendingSelection": "Enviando...",
    "connectionLost": "Reconectando..."
  },
  "reminders": {
    "title": "Meus Lembretes",
    "active": "Ativos",
    "today": "Hoje",
    "thisWeek": "Esta Semana",
    "history": "Histórico",
    "items": "itens",
    "emptyTitle": "Nenhum lembrete ainda",
    "emptySubtitle": "Crie um pelo chat e ele aparecerá aqui.",
    "emptyAction": "Abrir chat",
    "filterActive": "Ativos",
    "filterToday": "Hoje",
    "filterWeek": "Esta Semana",
    "filterHistory": "Histórico",
    "emptyState": "Nenhum lembrete ainda. Comece a conversar!",
    "swipeDone": "Concluído",
    "swipeSnooze": "Adiar",
    "swipeDelete": "Excluir",
    "search": "Buscar lembretes...",
    "upcoming": "Próximos",
    "completed": "Concluídos",
    "overdue": "Atrasados",
    "tomorrow": "Amanhã",
    "synced": "Sincronizado {{value}}",
    "swipeHint": "Deslize um lembrete para mais ações",
    "noResults": "Nenhum lembrete corresponde à busca",
    "noResultsHint": "Tente outra palavra-chave ou limpe a busca",
    "deleteAllFailed": "Falha ao excluir todos os lembretes"
  },
  "calendar": {
    "title": "Calendário",
    "today": "Hoje",
    "tomorrow": "Amanhã",
    "completed": "concluído",
    "noEvents": "Nada agendado",
    "noEventsSubtitle": "Escolha uma data para ver lembretes e eventos.",
    "googleEvent": "Google Calendar",
    "legendActive": "Ativo",
    "legendRecurring": "Recorrente",
    "legendDone": "Concluído",
    "legendGoogle": "Google",
    "previousMonth": "Mês anterior",
    "nextMonth": "Próximo mês",
    "previousYear": "Ano anterior",
    "nextYear": "Próximo ano",
    "goToToday": "Ir para hoje",
    "all": "Todos",
    "active": "Ativos",
    "done": "Concluídos",
    "paused": "Pausados"
  },
  "settings": {
    "title": "Configurações",
    "profile": "Perfil",
    "name": "Nome de exibição",
    "enterName": "Digite seu nome",
    "language": "Idioma",
    "uiLanguage": "Idioma do app",
    "uiLanguageHelp": "Altera a interface, rótulos do calendário e direção do layout neste dispositivo.",
    "serverLanguage": "Idioma do chat",
    "serverLanguageHelp": "Altera o idioma usado nas respostas do servidor e mensagens de lembrete para sua conta.",
    "timezone": "Fuso horário",
    "currentTimezone": "Fuso horário atual",
    "timezoneHelp": "Todos os horários dos lembretes são mostrados neste fuso horário.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Salvar fuso",
    "timezoneSaved": "Fuso horário atualizado",
    "detect": "Detectar",
    "detectFailed": "Não foi possível detectar o fuso horário",
    "autoDetect": "Detectar automaticamente pelo GPS",
    "notifications": "Notificações",
    "notificationsHelp": "Lembretes de acompanhamento controlam alertas repetidos após a entrega. Permissões são gerenciadas nas configurações do telefone.",
    "pushEnabled": "Notificações Push",
    "autoDoneOnFire": "Marcar como feito automaticamente",
    "autoDoneOnFireDesc": "Se desligado, lembretes permanecem ativos até marcar como feito.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Conectado",
    "googleDisconnected": "Não conectado",
    "googleConnectedHelp": "Novos lembretes podem ser sincronizados automaticamente.",
    "googleDisconnectedHelp": "Conecte o Google Calendar para alinhar lembretes e eventos.",
    "googleConnectFailed": "Falha ao conectar Google Calendar",
    "connected": "Conectado",
    "disconnected": "Não conectado",
    "connect": "Conectar",
    "disconnect": "Desconectar",
    "autoSync": "Sincronizar lembretes automaticamente",
    "autosync": "Sincronizar lembretes automaticamente",
    "subscription": "Assinatura",
    "trialUsed": "Teste: {{used}}/{{total}} usado",
    "trialStatus": "Teste disponível",
    "activeStatus": "Assinatura ativa",
    "expiredStatus": "Assinatura expirada",
    "unsubscribedStatus": "Não assinante",
    "about": "Sobre",
    "version": "Versão",
    "logout": "Sair",
    "logoutTitle": "Sair",
    "logoutConfirm": "Tem certeza que deseja sair?",
    "noName": "Nome não definido",
    "serverConnection": "Conexão com servidor",
    "serverUrl": "URL do servidor",
    "serverEdit": "Editar",
    "saveReconnect": "Salvar e reconectar",
    "resetDefault": "Restaurar padrão",
    "invalidServerUrlTitle": "URL do servidor inválida",
    "invalidServerUrlMessage": "Digite uma URL válida http ou https, por exemplo https://example.com",
    "uiLanguageChangeFailed": "Falha ao alterar idioma do app. Tente novamente.",
    "serverLanguageChangeFailed": "Falha ao alterar idioma do chat. Tente novamente.",
    "timezoneChangeFailed": "Falha ao alterar fuso horário. Tente novamente.",
    "autoSyncChangeFailed": "Falha ao atualizar sincronização automática. Tente novamente.",
    "nameChangeFailed": "Falha ao atualizar nome de exibição. Tente novamente.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalhes do lembrete",
    "editTime": "Editar horário",
    "rename": "Renomear",
    "snooze": "Adiar",
    "snooze15": "Adiar 15 minutos",
    "pause": "Pausar",
    "pauseReminder": "Pausar lembrete",
    "resume": "Retomar",
    "resumeReminder": "Retomar lembrete",
    "skip": "Pular próximo",
    "skipOccurrence": "Pular esta ocorrência",
    "syncGoogle": "Sincronizar com Google",
    "delete": "Excluir",
    "deleteTitle": "Excluir lembrete",
    "deleteConfirm": "Este lembrete será excluído permanentemente.",
    "deleteRecurringTitle": "Excluir lembrete recorrente",
    "deleteRecurringMessage": "Deseja pular esta ocorrência ou excluir toda a série?",
    "deleteThisOccurrence": "Pular esta ocorrência",
    "deleteEntireSeries": "Excluir toda a série",
    "done": "Concluído",
    "markDone": "Marcar como concluído",
    "undo": "Restaurar",
    "undoPrompt": "Precisa ativo novamente? Restaure agora.",
    "recurring": "Recorrente",
    "nextRun": "Próxima execução",
    "oneTime": "Único",
    "pending": "Pendente",
    "sent": "Enviado",
    "paused": "Pausado",
    "active": "Ativo",
    "snoozed": "Adiado",
    "localTime": "Mostrado no seu horário local",
    "recurrence": "Recorrência",
    "created": "Criado",
    "tags": "Tags",
    "fireCount": "Vezes disparado",
    "actions": "Ações",
    "none": "Nenhum",
    "snoozeFailed": "Falha ao adiar lembrete",
    "pauseFailed": "Falha ao pausar lembrete",
    "resumeFailed": "Falha ao retomar lembrete",
    "skipFailed": "Falha ao pular lembrete",
    "doneFailed": "Falha ao marcar lembrete como concluído",
    "undoFailed": "Falha ao restaurar status do lembrete",
    "deleteFailed": "Falha ao excluir lembrete",
    "rescheduleTitle": "Reagendar?",
    "rescheduleMsg": "Este lembrete está atrasado. Deseja reagendá-lo?",
    "reschedule15": "Em 15 minutos",
    "reschedule60": "Em 1 hora",
    "keepOverdue": "Manter como está"
  },
  "onboarding": {
    "slide1Title": "Bem-vindo ao FishMemory",
    "slide1Sub": "Seu assistente pessoal de lembretes — com WhatsApp e feito para seu bolso.",
    "slide2Title": "Basta conversar naturalmente",
    "slide2Sub": "Digite lembretes como pensa: \"Me lembre de ligar para a mãe amanhã às 15h\" — cuidamos do resto.",
    "slide3Title": "Nunca perca nada",
    "slide3Sub": "Receba notificações no tempo certo, organize com tags e fique no controle do que importa.",
    "getStarted": "Começar",
    "next": "Próximo",
    "firstReminderTitle": "Crie seu primeiro lembrete!",
    "firstReminderHint": "Tente digitar algo como:",
    "firstReminderExample": "Me lembre de beber água amanhã às 9h",
    "gotIt": "Entendi!",
    "notifRationaleTitle": "Fique no horário",
    "notifRationaleBody": "FishMemory precisa de notificações para lembrar você no momento certo. Você receberá alertas apenas dos lembretes criados.",
    "notifRationaleAllow": "Ativar notificações",
    "notifRationaleLater": "Talvez depois",
    "swipeHint": "Deslize para a direita para ações rápidas →",
    "calendarDragHint": "Arraste para expandir ↕"
  }
}
